import { BaseDataService } from "../../../services/base/BaseDataService";
import { ProjectDocWorkflowApprover } from "../models/ProjectDocWorkflowApprover";
import { ProjectDocWorkflowApproverQuery } from "../models/ProjectDocWorkflowApproverQuery";

export class ProjectDocWorkflowApproverService extends BaseDataService<ProjectDocWorkflowApprover, ProjectDocWorkflowApproverQuery> {
  protected prefixUrl: string = `ProjectDocWorkflowApprovers`;
}
